import { render } from "./InvoiceHeader.vue?vue&type=template&id=6e6e32d6&scoped=true"
import script from "./InvoiceHeader.vue?vue&type=script&lang=js"
export * from "./InvoiceHeader.vue?vue&type=script&lang=js"

import "./InvoiceHeader.vue?vue&type=style&index=0&id=6e6e32d6&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-6e6e32d6"

export default script